import { ClaimLoyaltyPromotionFailureReason } from '@sg/graphql-schema';

import { type ClaimOfferResponse, type Guard } from '../click-to-claim.machine.types';

// ─── Claim offer ─────────────────────────────────────────────────────────────

const checkIfClaimSucceeded: Guard<ClaimOfferResponse> = (_args, params) => {
  return params.result === 'Reward';
};

const checkIfOfferAlreadyClaimed: Guard<ClaimOfferResponse> = (_args, params) => {
  return getFailureReason(params) === ClaimLoyaltyPromotionFailureReason.PreviouslyIssued;
};

const checkIfOfferNewUserOnly: Guard<ClaimOfferResponse> = (_args, params) => {
  return getFailureReason(params) === ClaimLoyaltyPromotionFailureReason.CustomerIneligibleNewUserGate; // prettier-ignore
};

const checkIfOfferNotEligible: Guard<ClaimOfferResponse> = (_args, params) => {
  return getFailureReason(params) === ClaimLoyaltyPromotionFailureReason.CustomerIneligibleSegmentGate; // prettier-ignore
};

const checkIfOfferExpired: Guard<ClaimOfferResponse> = (_args, params) => {
  return getFailureReason(params) === ClaimLoyaltyPromotionFailureReason.ExpiredOffer;
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

const getFailureReason = (response: ClaimOfferResponse) => {
  return response.result === 'ClaimLoyaltyPromotionFailure' ? response.reason : undefined;
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfClaimSucceeded,
  checkIfOfferAlreadyClaimed,
  checkIfOfferNewUserOnly,
  checkIfOfferNotEligible,
  checkIfOfferExpired,
};
